const quotes = [
  { quote: "Compound interest is the eighth wonder of the world.<br/>He who understands it, earns it... he who doesn't... pays it.", author: "Albert Einstein" },
  { quote: "A goal without a plan is just a wish.", author: "Antoine de Saint-Exupéry" },
  { quote: "Do not save what is left after spending, but spend what is left after saving.", author: "Warren Buffett" },
  { quote: "The best way to predict the future is to create it.", author: "Peter Drucker" },
  { quote: "Beware of little expenses; a small leak will sink a great ship.", author: "Benjamin Franklin" },
  { quote: "It’s not your salary that makes you rich, it’s your spending habits.", author: "Charles A. Jaffe" },
  { quote: "An investment in knowledge pays the best interest.", author: "Benjamin Franklin" },
  { quote: "Know what you own, and know why you own it.", author: "Peter Lynch" },
  { quote: "Wealth consists not in having great possessions, but in having few wants.", author: "Epictetus" },
  { quote: "Time is the friend of the wonderful business.", author: "Warren Buffett" },
  { quote: "The future depends on what you do today.", author: "Mahatma Gandhi" },
  { quote: "It’s not how much money you make, but how much money you keep.", author: "Robert Kiyosaki" },
  { quote: "If you can’t measure it, you can’t improve it.", author: "Attributed to Peter Drucker" },
  { quote: "Fortune sides with him who dares.", author: "Virgil" },
  { quote: "Simplicity is the ultimate sophistication.", author: "Leonardo da Vinci" },
  { quote: "Never spend your money before you have it.", author: "Thomas Jefferson" },
  { quote: "Financial peace isn’t the acquisition of stuff.<br/>It’s learning to live on less than you make.", author: "Dave Ramsey" },
  { quote: "The stock market is a device for transferring money<br/>from the impatient to the patient.", author: "Warren Buffett" },
  { quote: "You must gain control over your money or the<br/>lack of it will forever control you.", author: "Dave Ramsey" },
  { quote: "A budget is telling your money where to go<br/>instead of wondering where it went.", author: "John C. Maxwell" },
  { quote: "The habit of saving is itself an education.", author: "T. T. Munger" },
  { quote: "Risk comes from not knowing what you’re doing.", author: "Warren Buffett" },
  { quote: "Someone’s sitting in the shade today<br/>because someone planted a tree a long time ago.", author: "Warren Buffett" },
  { quote: "The more you learn, the more you earn.", author: "Warren Buffett" },
  { quote: "Do not look for the needle in the haystack. Just buy the haystack.", author: "John C. Bogle" },
  { quote: "Money often costs too much.", author: "Ralph Waldo Emerson" },
  { quote: "Frugality includes all the other virtues.", author: "Cicero" },
  { quote: "It is not the man who has too little,<br/>but the man who craves more, that is poor.", author: "Seneca" },
  { quote: "An inch of gold will not buy an inch of time.", author: "Japanese proverb" },
  { quote: "Beware of small streams; they make great rivers.", author: "Attributed to Blaise Pascal" },
  { quote: "Order and simplification are the first steps toward mastery.", author: "Thomas Mann" }
];

export function getDailyQuote() {
  const dayOfMonth = new Date().getDate();
  const index = (dayOfMonth - 1) % quotes.length;
  return quotes[index];
}

export default quotes;
